/* global gsap */

export default class MainMenu {
	constructor() {
		this.offCanvas = document.getElementById('navbarNavOffcanvas');
		this.burgerButtonWrapper = document.querySelector('.burger-button-wrapper');
		this.menuItems = this.offCanvas.querySelectorAll('.menu-item');
		this.isWorking = false;
		this.events();
	}

	onKeyUpListener(ev) {
		if (ev.keyCode === 27) {
			document.querySelector('.burger-button-wrapper').dispatchEvent(new Event('click'));
		}
		return true;
	}

	onMainMenuOpen() {
		if (this.isWorking) return false;
		this.isWorking = true;
		const tl = gsap.timeline();
		this.offCanvas.classList.toggle('active');

		this.offCanvas.removeAttribute('aria-hidden');
		this.offCanvas.setAttribute('aria-modal', true);
		this.offCanvas.setAttribute('role', 'dialog');
		this.offCanvas.style.visibility = 'visible';

		document.body.classList.add('main-menu-open');

		gsap.set(this.menuItems, {opacity: 0,y: '-20px'});

		tl.to(this.offCanvas, {y: 0, duration: 0.6, onComplete: () => {

		}});

		tl.to(this.menuItems, {opacity: 1,y: 0, duration: 0.4, ease: "power4.inOut", stagger: 0.08}, "-=0.3");

		document.addEventListener('keyup', this.onKeyUpListener.bind(this), {once: true});
		document.body.classList.add('main-menu-open');
		window.dispatchEvent(new Event('mainMenu.open'));
		this.isWorking = false;

	}

	onMainMenuClose() {
		if (this.isWorking) return false;
		this.isWorking = true;
		const tl = gsap.timeline();
		this.offCanvas.classList.toggle('active');

		this.offCanvas.removeAttribute('aria-modal');
		this.offCanvas.removeAttribute('role');
		this.offCanvas.setAttribute('aria-hidden', true);

		document.body.classList.remove('main-menu-open');

		tl.to(this.offCanvas, {y: '-100%', duration: 0.6, onComplete: () => {
				this.offCanvas.style.visibility = 'hidden';
				this.isWorking = false;
				window.dispatchEvent(new Event('mainMenu.close'));
			}}, "-=0.2");
	}

	events() {
		window.addEventListener('burgerButton.open', this.onMainMenuOpen.bind(this), false);
		window.addEventListener('burgerButton.close', this.onMainMenuClose.bind(this), false);
	}
}
